export const ONBOARD_PENDING_STORAGE_KEY = 'onboardPending';

function lower(value) {
  return String(value).trim().toLowerCase();
}

export function isPendingOnboardingValue(value) {
  if (value === false || value === 0) return true;
  if (value === null || value === undefined || value === '') return false;
  return ['0', 'false', 'pending'].includes(lower(value));
}

export function isCompletedOnboardingValue(value) {
  if (value === true || value === 1) return true;
  if (value === null || value === undefined || value === '') return false;
  return ['1', 'true', 'complete', 'completed'].includes(lower(value));
}

function isTrueLike(value) {
  return value === true || value === 1 || ['1', 'true', 'y', 'yes'].includes(lower(value));
}

function numericId(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function isB2BUser(data = {}) {
  const source = data ?? {};
  const orgId = source.user_orgid
    ?? source.org_id
    ?? source.orgId
    ?? source.organization_id
    ?? source.user?.user_orgid
    ?? source.user?.org_id
    ?? source.org?.id
    ?? 0;
  const isRetail = source.is_retail
    ?? source.isRetail
    ?? source.user?.is_retail
    ?? source.user?.isRetail
    ?? null;

  return numericId(orgId) > 0 && !isTrueLike(isRetail);
}

export function inferOnboardingPending(data = {}, contextIntent = null) {
  if (isB2BUser(data)) return false;
  if (isPendingOnboardingValue(data.onboarding)) return true;
  if (isCompletedOnboardingValue(data.onboarding)) return false;
  if (
    isTrueLike(data.new_user) ||
    isTrueLike(data.newUser) ||
    isTrueLike(data.is_new_user) ||
    isTrueLike(data.isNewUser)
  ) return true;
  return contextIntent === 'signup';
}

export function readStoredOnboardingPending() {
  if (typeof localStorage === 'undefined') return false;
  return isPendingOnboardingValue(localStorage.getItem(ONBOARD_PENDING_STORAGE_KEY));
}

export function resolveOnboardingPending({ onboardingPending = false, user = null } = {}) {
  if (isB2BUser(user)) return false;
  if (isCompletedOnboardingValue(user?.onboarding)) return false;
  if (isPendingOnboardingValue(user?.onboarding)) return true;
  return !!onboardingPending || readStoredOnboardingPending();
}

export function syncStoredOnboardingPending(isPending) {
  if (typeof localStorage === 'undefined') return;
  if (isPending) {
    localStorage.setItem(ONBOARD_PENDING_STORAGE_KEY, '0');
  } else {
    localStorage.removeItem(ONBOARD_PENDING_STORAGE_KEY);
  }
}
